export default __webpack_public_path__ + "static/media/7.a0a7c8b2.png";